const C = {
  name: "Warsaw",
  dimensions: { width: 24, height: 24 },
  content: `
    <path d="M15 3H7V1H15V3Z" fill="currentColor"/>
    <path
        d="M7 7C7 5.34772 8.34772 4 10 4C11.6523 4 13 5.34772 13 7C13 7.54772 13.4523 8 14 8C14.5477 8 15 7.54772 15 7H17C17 8.65228 15.6523 10 14 10C12.3477 10 11 8.65228 11 7C11 6.45228 10.5477 6 10 6C9.45228 6 9 6.45228 9 7C9 7.54772 9.45228 8 10 8V10C8.34772 10 7 8.65228 7 7Z"
        fill="currentColor"/>
    <path
        d="M6.70726 4.70706L4.41436 6.99995L6.70726 9.29285L5.29304 10.7071L1.58594 6.99995L5.29304 3.29285L6.70726 4.70706Z"
        fill="currentColor"/>
    <path
        d="M9 13.5C9 11.567 10.567 10 12.5 10C14.433 10 16 11.567 16 13.5C16 15.433 14.433 17 12.5 17C12.489 17 12.478 16.9999 12.4671 16.9998C12.3927 18.3562 12.7317 19.7263 13.4678 20.9132C14.4261 20.7305 15.3174 20.2646 16.0097 19.5661L16.0128 19.5629L16.9258 18.65C16.7823 18.2722 16.4149 18 15.99 18V16C17.3384 16 18.484 16.8976 18.8597 18.1259C20.0954 18.497 21 19.6463 21 21H19C19 20.5724 18.7243 20.2029 18.3427 20.0615L17.4303 20.9739L17.4287 20.9754C16.1384 22.2767 14.3722 23 12.55 23C8.06918 23 4.77208 18.7784 5.85982 14.4275L5.86067 14.4241L5.99996 13.8751V12H7.99996V14.1249L7.7997 14.9142C7.14633 17.5313 8.72878 20.083 11.1611 20.8009C10.563 19.4033 10.3424 17.8778 10.513 16.3817C9.59892 15.7502 9 14.695 9 13.5ZM12.5 12C11.6716 12 11 12.6716 11 13.5C11 14.3284 11.6716 15 12.5 15C13.3284 15 14 14.3284 14 13.5C14 12.6716 13.3284 12 12.5 12Z"
        fill="currentColor"/>
  `
};
export {
  C as Warsaw
};
